/* eslint-disable */ import { detailComponent, entityHeaderComponent, memoEval, sceneEntitySelectHotspotComponent, staticPerspectiveCameraComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const rightLegComponents = [
    attachComponent.withComponent(staticPerspectiveCameraComponent, 'default', true).withEntity('RightLeg').withGradualFilter({
        selectedEntityIds: (self)=>self.id,
        viewStates: [
            'Default'
        ]
    }).attach(memoEval(()=>[], ()=>({
            priority: 2,
            fov: 35,
            near: 50,
            far: 2000,
            polarAngle: 1,
            minDistance: 300,
            maxDistance: 1000,
            lookAtY: -50,
            azimuthAngle: -0.7
        }))),
    attachComponent.withComponent(sceneEntitySelectHotspotComponent, 'select', true).withEntity('RightLeg').attach(memoEval(()=>[], ()=>({
            azimuthAngleLimits: {
                min: -1.5,
                max: 1.5
            },
            polarAngleLimits: {
                min: 0.1,
                max: 3
            },
            title: 'Right leg',
            offsetZ: 105,
            offsetX: -80,
            offsetY: -3
        }))),
    attachComponent.withComponent(detailComponent, 'default', true).withEntity('RightLeg').attach(memoEval(()=>[], ()=>({
            title: 'Right leg',
            subtitle: '',
            description: ''
        }))),
    attachComponent.withComponent(entityHeaderComponent, 'default', true).withEntity('RightLeg').attach(memoEval(()=>[], ()=>({})))
];

//# sourceMappingURL=right-leg.js.map